export const environment = {
  production: false,
  firebase: {
    projectId: 'doctorcity-globe',
    appId: '1:1051883467266:web:b84f96a6eb07bbd0052d1b',
    databaseURL: 'https://doctorcity-globe.firebaseio.com',
    storageBucket: 'doctorcity-globe.appspot.com',
    locationId: 'asia-southeast2',
    apiKey: 'AIzaSyCuDMPTKx_Lnuj-akXtfuqxlHTTQsXAmvU',
    authDomain: 'doctorcity-globe.firebaseapp.com',
    messagingSenderId: '1051883467266',
    measurementId: 'G-DKP45GRTZ1',
    vapidKey: 'BCK2T13R78KxQCEv_JEz35M-s_fjXmQlujN062DCu6-s6oT6SvyexLWS0-hXl49eOiplypTq0TpPN0eMopLxOag'
  },
  servicePrice: 100000
};
